<!-- eslint-disable vue/require-v-for-key -->
<template>
    <div class="inscription container-fluid mx-auto d-flex-center flex-column my-4 flex-fill body-container">
        <div v-if="isLoading" class="loader d-flex-center">
            <div class="loader__frame p-3 pt-4--5">
                <div class="spinner-border" role="status"></div>
                <strong class="mt-3">{{ t.loadingMsg }}</strong>
            </div>
        </div>

        <div class="row w-100">
            <div
                class="order-0 col-12 col-md col-xl-12 d-flex-center justify-content-md-start justify-content-xl-center"
            >
                <img src="../assets/img/logo.png" class="inscription__logo mb-4" alt="" />
            </div>
            <div class="col-12 order-3 col-md-auto order-md-1 col-xl inscription__img-congres">
                <img src="../assets/img/congres.png" alt="" />
            </div>
            <div class="order-2 col-12 col-xl-auto d-flex-center">
                <div class="inscription__form-section bg-200 p-3 py-sm-4 px-sm-4 shadow rounded-5">
                    <h1 class="mt-3 mb-4--5">{{ t.registerTitle }}</h1>

                    <form method="POST" class="inscription__form needs-validation" novalidate>
                        <div class="row g-4">
                            <!-- Participation -->
                            <div class="col m-0"></div>
                            <div class="col-12 col-sm-auto d-flex-center flex-wrap gap-3 text-center fs-4">
                                <span>{{ t.participateLabel }} :</span>
                                <div class="d-flex">
                                    <button
                                        type="button"
                                        class="btn btn-lg mx-3"
                                        v-bind:class="[
                                            form_data.is_participating ? 'btn-primary' : 'btn-outline-primary',
                                        ]"
                                        @click="participate(true)"
                                    >
                                        {{ t.yes }}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-lg"
                                        v-bind:class="[
                                            form_data.is_participating ? 'btn-outline-secondary' : 'btn-secondary',
                                        ]"
                                        @click="participate(false)"
                                    >
                                        {{ t.no }}
                                    </button>
                                </div>
                            </div>

                            <!-- Nom -->
                            <div class="col-12 col-sm-6">
                                <div class="form-floating">
                                    <input
                                        class="form-control text-uppercase"
                                        type="text"
                                        v-model="form_data.last_name"
                                        id="last_name"
                                        name="last_name"
                                        placeholder="Dupond"
                                        required
                                    />
                                    <label for="last_name">{{ t.lastNameLabel }}*</label>
                                    <div class="invalid-feedback">{{ t.lastNameInvalid }}</div>
                                </div>
                            </div>
                            <!-- Prenom -->
                            <div class="col-12 col-sm-6">
                                <div class="form-floating">
                                    <input
                                        class="form-control text-capitalize"
                                        type="text"
                                        v-model="form_data.first_name"
                                        id="first_name"
                                        name="first_name"
                                        placeholder="Alain"
                                        required
                                    />
                                    <label for="first_name">{{ t.firstNameLabel }}*</label>
                                    <div class="invalid-feedback">{{ t.firstNameInvalid }}</div>
                                </div>
                            </div>
                            <!-- email -->
                            <div class="col-12">
                                <div class="form-floating">
                                    <input
                                        class="form-control"
                                        type="email"
                                        v-model="form_data.email"
                                        id="email_address"
                                        name="email_address"
                                        placeholder="nom@exemple.fr"
                                        required
                                    />
                                    <label for="email_address">{{ t.emailLabel }}*</label>
                                    <div class="invalid-feedback">{{ t.emailInvalid }}</div>
                                </div>
                            </div>
                            <!-- company_name -->
                            <div class="col-12">
                                <div class="form-floating">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="form_data.company_name"
                                        id="company_name"
                                        name="company_name"
                                        placeholder="SAS COMPANY"
                                        required
                                    />
                                    <label for="company_name">{{ t.companyNameLabel }}*</label>
                                    <div class="invalid-feedback">{{ t.companyNameInvalid }}</div>
                                </div>
                            </div>
                            <!-- company_role -->
                            <div class="col-12">
                                <div class="form-floating">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="form_data.company_role"
                                        id="company_role"
                                        name="company_role"
                                        placeholder="SAS COMPANY"
                                        required
                                    />
                                    <label for="company_role">{{ t.companyRoleLabel }}*</label>
                                    <div class="invalid-feedback">{{ t.companyRoleInvalid }}</div>
                                </div>
                            </div>

                            <!-- groupe OB -->
                            <div class="col-12">
                                <div class="form-floating">
                                    <select
                                        required
                                        v-model="form_data.groupe_ob"
                                        class="form-select"
                                        aria-label="Groupe OB"
                                        id="groupe_ob"
                                        name="groupe_ob"
                                    >
                                        <option value="Dijon">Dijon</option>
                                        <option value="Talant">Talant</option>
                                        <option value="Beaune">Beaune</option>
                                    </select>
                                    <label for="groupe_ob">Groupe OB*</label>
                                    <div class="invalid-feedback">Veuillez renseigner votre groupe OB</div>
                                </div>
                            </div>

                            <!-- Is Accompanied -->
                            <template v-if="form_data.is_participating">
                                <div class="col-12 col-sm-auto d-flex-center text-center">{{ t.is_accompanied }} :</div>
                                <div class="col-12 col-sm-auto text-center">
                                    <button
                                        type="button"
                                        class="btn me-2"
                                        v-on:click="isAccompaniedChanged(true)"
                                        v-bind:class="[
                                            form_data.is_accompanied ? 'btn-primary' : 'btn-outline-primary',
                                        ]"
                                    >
                                        {{ t.yes }}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn"
                                        v-on:click="isAccompaniedChanged(false)"
                                        v-bind:class="[
                                            form_data.is_accompanied ? 'btn-outline-secondary' : 'btn-secondary',
                                        ]"
                                    >
                                        {{ t.no }}
                                    </button>
                                </div>
                                <div class="col"></div>
                                <div class="col-12 m-0"></div>

                                <template v-if="form_data.is_accompanied">
                                    <!-- Mates -->
                                    <div
                                        class="col-12 row mx-0 g-2 mb-2"
                                        v-for="(item, i) in form_data.mates"
                                        v-bind:key="i"
                                    >
                                        <div class="col-12">
                                            <div class="label-line-icon">
                                                <span class="label fs-4 fw-bold">#{{ i + 1 }}</span>
                                                <span class="line"></span>
                                                <span class="icon" v-if="form_data.mates?.length > 1">
                                                    <i
                                                        class="cursor-pointer fa-solid fa-trash-alt me-1 fa-lg"
                                                        @click="() => removeMate(i)"
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                        <!-- Nom Mate -->
                                        <div class="gy-1 col-12 col-sm-6" v-bind:key="`c0_${i}`">
                                            <div class="form-floating">
                                                <input
                                                    class="form-control text-uppercase"
                                                    type="text"
                                                    v-model="item.last_name"
                                                    v-bind:id="`last_name_${i}`"
                                                    v-bind:name="`last_name_${i}`"
                                                    placeholder="Dupont"
                                                    required
                                                />
                                                <label v-bind:for="`last_name_${i}`">Nom accompagnant(e)*</label>
                                            </div>
                                        </div>
                                        <!-- Prénom Mate -->
                                        <div class="gy-1 col-12 col-sm-6" v-bind:key="`c1_${i}`">
                                            <div class="form-floating">
                                                <input
                                                    class="form-control text-capitalize"
                                                    type="text"
                                                    v-model="item.first_name"
                                                    v-bind:id="`first_name_${i}`"
                                                    v-bind:name="`first_name_${i}`"
                                                    placeholder="Dupont"
                                                    required
                                                />
                                                <label v-bind:for="`first_name_${i}`">Prénom accompagnant(e)*</label>
                                            </div>
                                        </div>
                                        <!-- Société -->
                                        <div class="gy-1 col-12 col-sm-6" v-bind:key="`c3_${i}`">
                                            <div class="form-floating">
                                                <input
                                                    class="form-control"
                                                    type="text"
                                                    v-model="item.company_name"
                                                    v-bind:id="`company_name_${i}`"
                                                    v-bind:name="`company_name_${i}`"
                                                    placeholder="Dupont"
                                                    required
                                                />
                                                <label v-bind:for="`company_name_${i}`">Société*</label>
                                            </div>
                                        </div>
                                        <!-- Secteur d'activté -->
                                        <div class="gy-1 col-12 col-sm-6" v-bind:key="`c4_${i}`">
                                            <div class="form-floating">
                                                <input
                                                    class="form-control"
                                                    type="text"
                                                    v-model="item.company_sector"
                                                    v-bind:id="`company_sector_${i}`"
                                                    v-bind:name="`company_sector_${i}`"
                                                    placeholder="Dupont"
                                                    required
                                                />
                                                <label v-bind:for="`company_sector_${i}`">Secteur d'activité*</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Boutton ajouter un Mate -->
                                    <div class="col-12 text-center g-2" v-if="form_data.mates?.length < max_mates">
                                        <button
                                            @click="addNewMate"
                                            class="btn btn-sm btn-outline-primary"
                                            type="button"
                                        >
                                            <i class="fa-solid fa-plus me-2" />
                                            <span>Ajouter un accompagnant</span>
                                        </button>
                                    </div>
                                </template>
                            </template>

                            <!-- accept privacy policy -->
                            <div class="col-12" v-if="form_data.is_participating">
                                <div class="form-check me-4">
                                    <input
                                        id="chk_policy"
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="form_data.has_accepted_privacy_policy"
                                        required
                                    />
                                    <label class="form-check-label" for="chk_policy">{{ t.privacyPolicyLabel }}*</label>
                                </div>
                            </div>
                        </div>

                        <button @click="register" class="w-100 btn btn-primary btn-lg mt-3" type="button">
                            {{ t.validateBtn }}
                        </button>
                        <div class="mt-2 small">* {{ t.requiredField }}</div>
                    </form>
                </div>
            </div>
            <div class="col-auto col-xl-1 order-4"></div>
        </div>
    </div>
</template>

<script>
import { t } from "../locale/language";
import router from "../plugins/router";
import { saveRegistration } from "@/plugins/server";

const empty_form = {
    is_participating: true,
    first_name: "",
    last_name: "",
    email: "",
    company_name: "",
    company_role: "",
    groupe_ob: "",
    is_accompanied: false,
    has_accepted_privacy_policy: false,
    mates: [],
};

const emptyMate = {
    first_name: "",
    last_name: "",
    company_name: "",
    company_sector: "",
};

export default {
    props: {
        token: null,
    },
    created() {
        // this.form_data = testForm;
    },
    data() {
        return {
            isLoading: false,
            hasError: false,
            max_mates: 3,
            t,
            form_data: {
                is_participating: true,
                last_name: "",
                first_name: "",
                email: "",
                company_name: "",
                company_role: "",
                groupe_ob: "",
                is_accompanied: false,
                has_accepted_privacy_policy: false,
                mates: [],
            },
        };
    },
    methods: {
        participate(is_participating) {
            this.form_data.is_participating = is_participating;
            this.form_data.has_accepted_privacy_policy &&= is_participating;

            if (!is_participating) this.isAccompaniedChanged(false);
        },
        isAccompaniedChanged(is_accompanied) {
            if (this.form_data.is_accompanied === is_accompanied) return;

            this.form_data.is_accompanied = is_accompanied;

            is_accompanied ? this.form_data.mates.push({ ...emptyMate }) : (this.form_data.mates = []);
        },
        addNewMate() {
            if (this.form_data.mates.length < this.max_mates) this.form_data.mates.push({...emptyMate});
        },
        removeMate(i) {
            this.form_data.mates.splice(i, 1);
        },
        async register() {
            if (!this.isLoading) {
                this.isLoading = true;
                const form = document.querySelector(".needs-validation");
                form.classList.add("was-validated");

                const notif = {
                    isValid: false,
                    participate: this.form_data.is_participating,
                };

                if (form.checkValidity()) {
                    const data = {
                        ...this.form_data,
                    };

                    await saveRegistration(data)
                        .then(async (result) => {
                            const data = result.data;
                            if (data.isValid) {
                                notif.isValid = true;
                            }
                        })
                        .catch((error) => {
                            const code = error.code;
                            const message = error.message;
                            const details = error.details;
                            console.log(code, message, details);
                            this.$data.hasError = true;
                        });

                    localStorage.p = JSON.stringify(notif);
                    this.cleanData();
                    router.push({ name: "done" });
                }

                this.isLoading = false;
            }
        },
        cleanData() {
            this.form_data = Object.assign({}, empty_form);
            const form = document.querySelector(".needs-validation");
            form?.classLis?.remove("was-validated");
        },
    },
};
</script>
